import * as React from 'react';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import {Button, ButtonGroup} from 'reactstrap';
import validate from './validate-form';
import renderSelectField from '../../../../theme/components/form/Select';
import {error} from '../../../../utils/notification-actions';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {IFuerzaVenta} from '../../../../utils/constants';

interface IState {
    periodos: string[];
}

interface IProps extends ReduxProps {
    fuerzaVenta?: IFuerzaVenta;
    handlePeriodoChange: () => {};
}

class VisicoolerClienteForm extends React.PureComponent<InjectedFormProps & IProps, IState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);

        this.state = {
            periodos: []
        };
    };

    public componentWillReceiveProps(newProps) {
        if (newProps.fuerzaVenta) {
            this.fetchPeriodos(newProps.fuerzaVenta.id);
        }
    }

    private async fetchPeriodos(fuerzaVentaId: string) {
        try {
            const response = await this.apiClient.obtenerPeriodosVisicoolers(fuerzaVentaId);
            this.setState({periodos: response});
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al obtener periodos'));
        }
    }

    public render() {
        const {handleSubmit} = this.props;

        return (
            <form className='form col-md-5 ' onSubmit={handleSubmit}>
                <div className='col-lg-6'>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Periodo </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='periodo'
                                component={renderSelectField}
                                onChange={this.props.handlePeriodoChange}
                                placeholder='Seleccione'
                                type='text'
                                options={this.state.periodos.map((per) => {
                                    return {value: per, label: per}
                                })}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-lg-6' style={{marginTop: 22}}>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>
                </div>
            </form>
        )
    }
}

export default reduxForm({
    form: 'visicooler_cliente_form', // a unique identifier for this form
    validate,
})(VisicoolerClienteForm);



// WEBPACK FOOTER //
// ./src/components/pages/visicooler/clientes/visicooler-cliente-form.tsx